import React from 'react'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import CounterSelectors from 'redux-modules/counter/CounterSelectors'
import {
  increment,
  incrementAsync,
  decrement,
  decrementAsync
} from 'redux-modules/counter/CounterActionCreators'

const CounterView = props => (
  <div>
    <h1>CounterView</h1>
    <p>Count: {props.count}</p>

    <p>
      <button className="btn btn-primary" onClick={props.increment}>Increment</button>
      <button className="btn btn-primary" onClick={props.incrementAsync} disabled={props.isIncrementing}>
        Increment Async
      </button>
    </p>

    <p>
      <button className="btn btn-primary" onClick={props.decrement}>Decrement</button>
      <button className="btn btn-primary" onClick={props.decrementAsync} disabled={props.isDecrementing}>
        Decrement Async
      </button>
    </p>

    <p>
      <button className="btn btn-primary" onClick={() => props.changePage()}>
        Go to about page via redux
      </button>
    </p>
      <div>
          <i className="fa fa-address-book" />
      </div>
  </div>
)

const mapStateToProps = ( state, props ) => ({
  count: CounterSelectors.countSelector(state),
  isIncrementing: CounterSelectors.isIncrementingSelector(state),
  isDecrementing: CounterSelectors.isDecrementingSelector(state)
})

const mapDispatchToProps ={
      increment,
      incrementAsync,
      decrement,
      decrementAsync,
      changePage: () => push('/about-us')
    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CounterView)



// WEBPACK FOOTER //
// ./src/croutes/counter/index.js